// @flow
import React, { useState } from 'react'
import MultiSelect from '../controls/MultiSelect'
import styled, { type StyledComponent } from 'styled-components'
import Button from '../controls/PrimaryButton'
import scrollToTop from '../../shared/scrollToTop'
import ErrorText from '../controls/ErrorText'
import _ from 'lodash'

export type Initial = {|
  advertisement_templates: Array<{| id: number, name: string, list: Array<string> |}>,
  audiences: Array<{| id: number, name: string, list: Array<string> |}>
|}

type Props = {|
  showRequestButton: boolean,
  advertisementTemplateOptions: Array<Object>,
  advertisementTemplateIds: Array<number>,
  advertisementTemplateIdsErrors: Array<string>,
  initial: Initial,
  onChange: (Object) => void,
  onPersist: ({| onSuccess: () => void, onFailure: () => void |}) => void,
  isLoading: boolean,
  notMatchedTemplates: Array<{| name: string, fixUrl: string |}>
|}

const Wrapper: StyledComponent<Object, any, any> = styled.div`
  max-width: 675px;
`
const Row: StyledComponent<Object, any, any> = styled.div`
  padding-bottom: 14px;
`
const Warning: StyledComponent<Object, any, any> = styled.div`
  font-size: 20px;
  padding: 12px 0;
`
const NotMatchedTemplateLine: StyledComponent<Object, any, any> = styled.div`
  padding-bottom: 4px;
`
const ButtonSpacer: StyledComponent<Object, any, any> = styled.div`
  height: 30px;
`

const t = {
  placeholder: 'Выберите шаблоны...',
  assign: 'Связать аудитории с шаблонами',
  not_matched_templates: 'Шаблоны с недостающими данными',
  fix: 'дозаполнить'
}

export default function AssignmentForm(props: Props) {
  const [isPersisted, setPersistedFlag] = useState(false)

  return (
    <Wrapper className="t-AssignmentForm">
      <Row>
        <MultiSelect
          value={props.advertisementTemplateIds}
          options={props.advertisementTemplateOptions}
          onChange={(ids) =>
            props.onChange({ advertisementTemplateIds: ids, advertisementTemplateIdsErrors: [] })
          }
          placeholder={t.placeholder}
        />
        <ErrorText errors={props.advertisementTemplateIdsErrors} />
      </Row>
      {!_.isEmpty(props.notMatchedTemplates) && <Warning>{t.not_matched_templates}</Warning>}
      {_.map(props.notMatchedTemplates, (item, index: number) => (
        <NotMatchedTemplateLine key={index}>
          <span>{item.name}</span>{' '}
          <a key={index} href={item.fixUrl} target="_blank">
            {t.fix}
          </a>
        </NotMatchedTemplateLine>
      ))}
      {props.showRequestButton && (
        <Row>
          <ButtonSpacer />
          <Button
            height={32}
            disabled={props.isLoading || isPersisted}
            onClick={() =>
              props.onPersist({
                onSuccess: () => {
                  setPersistedFlag(true)
                  window.location = '/advertisement_templates'
                },
                onFailure: () => {
                  scrollToTop()
                }
              })
            }
          >
            {t.assign + (props.isLoading ? '...' : '')}
          </Button>
        </Row>
      )}
    </Wrapper>
  )
}
